<div class="row p-2 mb-4">
    <div class="col-12 text-end">
        <app-header></app-header>
    </div>
  </div>

<div class="mb-3 card">
    <div class="card-body">
    <ul class="nav nav-tabs nav-justified mb-3">
     <li class="nav-item">
    <a role="tab" class="nav-link active" id="tab-c1-0" data-bs-toggle="tab" data-bs-target="#tab-animated1-0" href="#tab-animated1-0" aria-selected="true">
    <span class="nav-text">Information personnelle</span>
    </a>
    </li>
    <li class="nav-item">
    <a role="tab" class="nav-link" id="tab-c1-1" data-bs-toggle="tab" data-bs-target="#tab-animated1-1" href="#tab-animated1-1" aria-selected="false">
    <span class="nav-text">Mot de passe</span>
    </a>
    </li>
    <li class="nav-item" *ngIf="user.is_signer">
    <a role="tab" class="nav-link" id="tab-c1-2" data-bs-toggle="tab" data-bs-target="#tab-animated1-2" href="#tab-animated1-2" aria-selected="false">
    <span class="nav-text">Signature</span>
    </a>
    </li>
    <!--li class="nav-item">
    <a role="tab" class="nav-link" id="tab-c1-2" data-bs-toggle="tab" data-bs-target="#tab-animated1-2" href="#tab-animated1-2" aria-selected="false">
    <span class="nav-text"></span>
    </a>
    </li-->
    </ul>
    <div class="tab-content">
    <div class="tab-pane active" id="tab-animated1-0" role="tabpanel">
        <form class="" #userForm="ngForm" (ngSubmit)="update(userForm.value)">
            <div class="position-relative form-group">
            <label for="exampleEmail" class="">Email</label>
            <input name="email" id="exampleEmail" placeholder="Email ici..." type="email" class="form-control" required [(ngModel)]="user.email">
            </div>
     
      
        
            <button class="mt-1 btn btn-warning" [disabled]="userForm.invalid || loading" type="submit">Sauvegarder mes informations  <app-loading [isVisible]="loading"></app-loading></button>
    </form>
    </div>
    <div class="tab-pane" id="tab-animated1-1" role="tabpanel">
        <form class="" #mpForm="ngForm" (ngSubmit)="changePassword(mpForm.value)">
            <div class="position-relative form-group">
            <label for="exampleEmail" class="">Ancien mot de passe</label>
            <input name="old_password" id="exampleEmail" placeholder="Ancien mot de passe" type="password" class="form-control" required ngModel>
            </div>
            <div class="position-relative form-group">
                <label for="exampleEmail" class="">Nouveau mot de passe</label>
                <input name="new_password" id="exampleEmail" placeholder="Nouveau mot de passe" type="password" class="form-control" required ngModel>
                </div>
                <div class="position-relative form-group">
                    <label for="exampleEmail" class="">Confirmer moot de passe</label>
                    <input name="confirm_password" id="exampleEmail" placeholder="Confirmer mot de passe" type="password" class="form-control" required ngModel>
                    </div>
     
      
        
            <button class="mt-1 btn btn-success" [disabled]="mpForm.invalid || loading" type="submit">Changer le mot de passe  <app-loading [isVisible]="loading"></app-loading></button>
    </form>
    </div>
    <div *ngIf="user.is_signer" class="tab-pane" id="tab-animated1-2" role="tabpanel">
        <form class="" #mpForm="ngForm" (ngSubmit)="storeSign(mpForm.value)">
            <div class="text-center mb-1">
                <img [src]="fileSrc" class="img-thumbnail" alt="..." style="height: 200px; width: 200px;">
            </div>
            <div class="text-center form-group mb-3">
                <label for="">Charger la signature numérisée</label>
                <input type="file" accept='image/*' (change)="loadImg($event)" class="form-control" />
            </div>

            <button class="mt-1 btn btn-success" [disabled]="mpForm.invalid || loading" type="submit">Charger ma signature <app-loading [isVisible]="loading"></app-loading></button>
    </form>
    </div>
    <!--div class="tab-pane" id="tab-animated1-2" role="tabpanel">
    <p class="mb-0">It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus
    PageMaker including versions of Lorem Ipsum.</p>
    </div-->
    </div>
    </div>
    </div>